import { Skeleton } from '@/components/ui/skeleton'

interface DrawerSkeletonProps {
  sections?: number
  showHeader?: boolean
  showFooter?: boolean
}

export function DrawerSkeleton({ 
  sections = 3,
  showHeader = true,
  showFooter = true
}: DrawerSkeletonProps) {
  return (
    <div className="flex flex-col h-full">
      {showHeader && (
        <div className="px-6 py-4 border-b">
          <Skeleton className="h-6 w-[200px]" />
        </div>
      )}
      
      <div className="flex-1 p-6 space-y-6">
        {Array.from({ length: sections }).map((_, i) => (
          <div key={i} className="space-y-3">
            <Skeleton className="h-4 w-[100px]" />
            <Skeleton className="h-10 w-full" />
            {i === 0 && <Skeleton className="h-4 w-[80%]" />}
          </div>
        ))}
        
        <div className="space-y-3">
          <Skeleton className="h-4 w-[120px]" />
          <div className="space-y-2">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-[60%]" />
          </div>
        </div>
      </div>
      
      {showFooter && (
        <div className="px-6 py-4 border-t flex justify-end gap-3">
          <Skeleton className="h-10 w-[100px]" />
          <Skeleton className="h-10 w-[100px]" />
        </div>
      )}
    </div>
  )
}